@let filesArr = files();
<div
  class="input-wrapper"
  [ngClass]="{
    'has-addon': hasAddon(),
    'has-attachment': filesArr && filesArr.length > 0,
    rounded: rounded(),
    large: large(),
  }">
  @if (filesArr && filesArr.length > 0) {
    <div class="attachments-wrapper">
      @for (file of filesArr; track $index) {
        @let fileKind = file.file.type | fileKind;
        <div class="attachment" [ngClass]="'attachment-type-' + fileKind">
          @switch (fileKind) {
            @case ('IMAGE') {
              @if (file.src) {
                <button
                  type="button"
                  class="button-reset delete-image-icon"
                  [attr.aria-label]="'Delete attachment'"
                  (click)="deleteAttachment($index)"
                  (keydown)="onDeleteAttachmentKeyDown($event, $index)">
                  <orbit-fa-icon [iconName]="closeIcon" />
                </button>
                <img [src]="file.src" alt="" />
              }
            }
            @case ('VIDEO') {
              <orbit-fa-icon class="video-file-icon" [iconName]="videoFileIcon" />
              <button
                type="button"
                class="button-reset delete-video-icon"
                [attr.aria-label]="'Delete attachment'"
                (click)="deleteAttachment($index)"
                (keydown)="onDeleteAttachmentKeyDown($event, $index)">
                <orbit-fa-icon [iconName]="closeIcon" />
              </button>
            }
            @case ('AUDIO') {
              <audio controls [src]="file.src"></audio>
              <button
                type="button"
                class="button-reset delete-audio-icon"
                [attr.aria-label]="'Delete attachment'"
                (click)="deleteAttachment($index)"
                (keydown)="onDeleteAttachmentKeyDown($event, $index)">
                <orbit-fa-icon [iconName]="closeIcon" />
              </button>
            }
          }
        </div>
      }
    </div>
  }

  @let rightAddon = addonRight();
  @let leftAddon = addonLeft();
  <div
    class="form-field-wrapper"
    [ngClass]="{
      'has-addon': hasAddon(),
      'addon-left': leftAddon?.button || leftAddon?.icon,
      'addon-right': rightAddon?.button || rightAddon?.icon,
    }">
    @if (leftAddon) {
      <div
        class="addon left-addon"
        [style.align-self]="leftAddon.vAlign ?? 'center'"
        [class.addon-disabled]="(leftAddon?.disabled ?? false) || disabled()">
        @if (leftAddon.button) {
          <orbit-button
            [rounded]="rounded()"
            [outlined]="leftAddon?.outlined ?? false"
            [flat]="leftAddon?.flat ?? false"
            [disabled]="(leftAddon?.disabled ?? false) || disabled()"
            [icon]="leftAddon?.icon"
            [ariaLabel]="leftAddon?.ariaLabel"
            [label]="leftAddon?.label"
            [testId]="leftAddon?.testId"
            (buttonClick)="emitAddonButtonClicked()"
            (keydown)="onAddonButtonKeyDown($event)" />
        } @else if (leftAddon.icon) {
          <button
            type="button"
            class="button-reset simple-icon"
            [tabindex]="(leftAddon?.disabled ?? false) || disabled() ? -1 : 0"
            [attr.aria-label]="'Addon action'"
            [class.disabled]="(leftAddon?.disabled ?? false) || disabled()"
            [attr.aria-disabled]="(leftAddon?.disabled ?? false) || disabled() ? true : null"
            [disabled]="(leftAddon?.disabled ?? false) || disabled()"
            (click)="onAddonIconClick(leftAddon)"
            (keydown)="onAddonIconKeyDown($event, leftAddon)">
            <orbit-fa-icon [iconName]="leftAddon.icon" />
          </button>
        } @else if (leftAddon.label) {
          <span class="addon-label">{{ leftAddon.label }}</span>
        }
      </div>
    }

    @if (inputType() === 'textarea') {
      <textarea
        #textarea
        [attr.id]="inputId()"
        [attr.aria-label]="ariaLabel() || null"
        [attr.placeholder]="placeholder()"
        [attr.aria-describedby]="ariaDescribedBy() || null"
        [attr.data-testid]="testId()"
        [name]="name()"
        (keydown)="typing($event)"
        (keydown.enter)="emitEnterPressed($event, true)"
        (blur)="blurred.emit()"
        [formControl]="controller()"
        autosize
        [minRows]="textareaAutosizeLimit().minRows"
        [maxRows]="textareaAutosizeLimit().maxRows"></textarea>
    } @else {
      <input
        #input
        [autocomplete]="autocomplete() ? 'on' : 'off'"
        [type]="inputType()"
        [attr.id]="inputId()"
        [attr.aria-label]="ariaLabel() || null"
        [attr.placeholder]="placeholder()"
        [attr.aria-describedby]="ariaDescribedBy() || null"
        [attr.data-testid]="testId()"
        [name]="name()"
        (keydown)="typing($event)"
        (keydown.enter)="emitEnterPressed($event)"
        (blur)="blurred.emit()"
        [formControl]="controller()" />
    }

    @if (rightAddon) {
      <div
        class="addon right-addon"
        [style.align-self]="rightAddon.vAlign ?? 'center'"
        [class.addon-disabled]="(rightAddon?.disabled ?? false) || disabled()">
        @if (rightAddon.button) {
          <orbit-button
            [rounded]="rounded()"
            [outlined]="rightAddon?.outlined ?? false"
            [flat]="rightAddon?.flat ?? false"
            [disabled]="(rightAddon?.disabled ?? false) || disabled()"
            [icon]="rightAddon?.icon"
            [ariaLabel]="rightAddon?.ariaLabel"
            [label]="rightAddon?.label"
            [testId]="rightAddon?.testId"
            (buttonClick)="emitAddonButtonClicked()"
            (keydown)="onAddonButtonKeyDown($event)" />
        } @else if (rightAddon.icon) {
          <button
            type="button"
            class="button-reset simple-icon"
            [tabindex]="(rightAddon?.disabled ?? false) || disabled() ? -1 : 0"
            [attr.aria-label]="'Addon action'"
            [class.disabled]="(rightAddon?.disabled ?? false) || disabled()"
            [attr.aria-disabled]="(rightAddon?.disabled ?? false) || disabled() ? true : null"
            [disabled]="(rightAddon?.disabled ?? false) || disabled()"
            (click)="onAddonIconClick(rightAddon)"
            (keydown)="onAddonIconKeyDown($event, rightAddon)">
            <orbit-fa-icon [iconName]="rightAddon.icon" />
          </button>
        } @else if (rightAddon.label) {
          <span class="addon-label">{{ rightAddon.label }}</span>
        }
      </div>
    }
  </div>
</div>
